/**
 * Panel Coordinator - ensures only one panel (diagram, spreadsheet, PDF) is open at a time.
 * When a panel opens, all others close first with animation.
 */

const closers = {};

export const registerPanel = (name, closeFn) => {
  closers[name] = closeFn;
};

export const closeAllPanels = () => {
  Object.values(closers).forEach(closeFn => closeFn());
};

export const closeOtherPanels = (exceptName) => {
  let hadOpen = false;
  Object.entries(closers).forEach(([name, closeFn]) => {
    if (name !== exceptName) {
      if (closeFn()) hadOpen = true; // closeFn returns true if it was open
    }
  });
  return hadOpen;
};
